
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company_personas",
      function () {
        return require("private-next-pages/company_personas/index.tsx");
      }
    ]);
  